export default {
	namespaced: true,
	state: {
		images: [],
		index: 0
	},
	getters: {
		images:	state => state.images,
		index:	state => state.index
	},
	actions: {
		hide(c) {
			c.commit('SET_IMAGES', [], 0);
		},
		show(c, { images, index }) {
			c.commit('SET_IMAGES', images, index);
		}
	},
	mutations: {
		SET_IMAGES(state, images, index) {
			state.images	= images;
			state.index		= index;
		}
	}
};